module.exports = __webpack_public_path__ + "media/images/athletes/88-22e59377c97dc3f925c7103aa6ad7fe7.png";